export default __webpack_public_path__ + "static/media/36I-102635_-15563_0.de345d72.jpg";